module.exports = __webpack_public_path__ + "static/media/act.da669a12.jpeg";